<script setup>
import { Head, useForm } from '@inertiajs/vue3';
import GuestLayout from '@/Layouts/GuestLayout.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import TextInput from '@/Components/TextInput.vue';

defineProps({
    status: {
        type: String,
        default: '',
    },
    users: {
        type: Array,
        default: () => [],
    },
});

const form = useForm({
    email: '',
    password: '',
});

const submit = () => {
    form.post(route('login'), {
        onFinish: () => form.reset('password'),
    });
};
</script>

<template>
    <GuestLayout>
        <Head title="Log in" />
        <template
            v-if="users"
            #noGutter
        >
            <div class="shopFloorLoginSection">
                <v-row>
                    <v-col
                        cols="12"
                        class="d-inline-flex flex-wrap align-center mx-8"
                    >
                        <p
                            class="d-inline-flex text-white bold text-no-wrap px-1 ml-3 fs-30"
                        >
                            Select Shop Floor User...
                        </p>
                        <template
                            v-for="user in [
                                'space',
                                ...users
                            ]"
                            :key="user.id"
                        >
                            <v-btn
                                v-if="user !== 'space'"
                                color="primaryshade"
                                class="tabletLoginButton my-4 mx-4"
                                :href="route('tablet.login', user)"
                                width="274"
                                height="100"
                            >
                                {{ user.forename }} {{ user.surname }}
                            </v-btn>
                            <div
                                v-else
                                class="d-inline-flex"
                                style="width: 280px; height: 100px;"
                            />
                        </template>
                    </v-col>
                </v-row>
            </div>
        </template>
        <v-alert
            v-if="status"
            class="mb-5"
            type="success"
            :text="status"
        />
        <form
            @submit.prevent="submit"
        >
            <v-row>
                <v-col cols="12">
                    <div class="fs-30 font-weight-bold">
                        <span v-if="users">Or Log In for Admin area...</span>
                        <span v-else>Log In for Admin Area...</span>
                    </div>
                </v-col>
                <v-col cols="12">
                    <TextInput
                        id="email"
                        type="email"
                        label="Username *"
                        color="white"
                        class="mt-1 block w-full"
                        v-model="form.email"
                        :errormessages="form.errors.email"
                        required
                        autofocus
                        autocomplete="username"
                    />
                </v-col>
                <v-col cols="12">
                    <TextInput
                        id="password"
                        type="password"
                        label="Password *"
                        class="mt-1 block w-full"
                        v-model="form.password"
                        :errormessages="form.errors.password"
                        required
                        autocomplete="current-password"
                    />
                </v-col>
                <v-col>
                    <PrimaryButton
                        variant="flat"
                        class="ms-4 float-right"
                        :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing"
                        prepend-icon="far fa-right-to-bracket"
                    >
                        Log in
                    </PrimaryButton>
                </v-col>
            </v-row>
        </form>
    </GuestLayout>
</template>

<style scoped>
.v-text-field input {
  color: rbg(var(--v-theme-white)) !important;
}

.shopFloorSection {
  background-color: rbg(var(--v-theme-textdim)) !important;
}

.tabletLoginButton {
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 24px !important;
}

.shopFloorLoginSection {
  background-color: rgb(var(--v-theme-textdim)) !important;
  border-bottom: 5px rgb(var(--v-theme-primary)) solid;
}

.fs-30 {
  font-size: 30px !important;
}
</style>
